<template>
    <div class="personal">
        <van-form @submit="onSubmit" ref="formRef">
            <van-cell-group inset>
                <van-field v-model="params.name" label="真实姓名" placeholder="请输入真实姓名"
                    :rules="[{ required: true, message: '请输入真实姓名' }]" />
                <van-field v-model="params.idcardNumber" label="身份证号码" placeholder="请输入身份证号码"
                    :rules="[{ required: true, message: '请输入身份证号码' }, { validator: validateIdCard, message: '身份证号码格式错误' }]" />
                <van-field v-model="params.email" label="个人邮箱" placeholder="请输入个人邮箱"
                    :rules="[{ validator: validateEmail, message: '邮箱格式错误' }]" />
                <van-field v-model="addressText" is-link readonly label="联系地址" placeholder="请选择省市区"
                    @click="showAddressPicker = true" />
                <van-field v-model="params.addressDetail" label=" " placeholder="请输入详细地址" />
            </van-cell-group>
        </van-form>
        <p class="label">上传身份证:</p>
        <div class="row">

            <div class="idcard"
                :style="{ backgroundImage: params.idcardFront ? 'url(' + params.idcardFront + ')' : '' }">
                <input type="file" @change="e => uploadImage(e, true)">
            </div>
            <div class="idcard" :style="{ backgroundImage: params.idcardBack ? 'url(' + params.idcardBack + ')' : '' }">
                <input type="file" @change="e => uploadImage(e, false)">
            </div>

        </div>

        <div class="desc">
            <h5>身份证拍摄要求:</h5>
            <p>1.身份证全部信息清晰可见无遮挡</p>
            <p>2.请勿进行任何软件处理</p>
        </div>

        <van-popup v-model:show="showAddressPicker" position="bottom">
            <van-area :area-list="areaList" @confirm="onAddressConfirm" @cancel="showAddressPicker = false" />
        </van-popup>

        <footer>
            <span class="auth-btn limit plain" @click="emit('prev')">上一步</span>
            <span class="auth-btn limit" @click="confirm">提交审核</span>
        </footer>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
// import QRCode from 'qrcode'
import axios from 'axios';
import { showNotify } from 'vant'
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { client } from '@/request/oss'

const store = useStore()
const props = defineProps({
    type: Number
})
const emit = defineEmits(['prev'])
const showAddressPicker = ref(false)
const areaList = reactive({
    province_list: {},
    city_list: {},
    county_list: {}
})

const params = reactive({
    name: '',
    idcardType: 1,
    idcardNumber: '',
    email: '',
    address: '',
    province: '',
    city: '',
    area: '',
    addressDetail: '',
    idcardFront: '',
    idcardBack: ''
})

const addressText = ref('')

const validateIdCard = (value) => {
    return /^[1-9]\d{16}[\dXx]$/.test(value)
}

const validateEmail = (value) => {
    if (!value) return true
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
}

onMounted(() => {
    axios.get('https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/data/ChinaCitys.json').then(res => {
        const data = res.data
        const provinceList = {}
        const cityList = {}
        const countyList = {}
        data.forEach(p => {
            provinceList[p.code] = p.province
            p.citys.forEach(c => {
                cityList[c.code] = c.city
                c.areas.forEach(a => {
                    countyList[a.code] = a.area
                })
            })
        })
        Object.assign(areaList, { province_list: provinceList, city_list: cityList, county_list: countyList })
    })
})

const onAddressConfirm = (values) => {
    params.province = values.selectedOptions[0].text
    params.city = values.selectedOptions[1].text
    params.area = values.selectedOptions[2].text
    addressText.value = `${params.province} ${params.city} ${params.area}`
    showAddressPicker.value = false
}

const uploadImage = (e, type) => {
    const file = e.target.files[0]
    const extName = file.name.slice(file.name.lastIndexOf('.'))
    client.setBucket('dfsk-3d')
    client.put(`cover/${Date.now() + extName}`, file).then(result => {
        if (type) {
            params.idcardFront = result.url
        } else {
            params.idcardBack = result.url
        }
    })
}

const onSubmit = () => {
    confirm()
}

const confirm = () => {
    if (!params.idcardFront || !params.idcardBack) {
        showNotify({ type: 'warning', message: '请上传身份证' })
        return
    }
    http.put('/app-api/member/user/updateUserAuthInfo', {
        id: store.state.login.userInfo.id,
        name: params.name,
        idcardType: 1,
        idcardNumber: params.idcardNumber,
        email: params.email,
        address: params.province + ',' + params.city + ',' + params.area + ',' + params.addressDetail,
        idcardFront: params.idcardFront,
        idcardBack: params.idcardBack,
        userType: 0
    }).then(res => {
        if (res) {
            showNotify({ type: 'success', message: '提交成功' })
            emit('next', 2)
        } else {
            showNotify({ type: 'danger', message: res.msg || '提交失败' })
        }
    })
}
</script>

<style scoped lang="scss">
.auth-btn {
    width: 170rem;
    height: 40rem;
    background: #000;
    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    &.limit {
        width: 170rem;
    }

    &.plain {
        background-color: #fff;
        color: rgba(0, 0, 0, 1);
    }

    &.block {
        width: 500rem;
        margin: 0 auto;
    }
}

.personal {
    width: 100%;
    margin-top: 50rem;
    background-color: #fff;
    padding: 30rem 0;

    .label {
        margin: 20rem;
    }

    .row {
        display: flex;
        margin-top: 20rem;
        justify-content: center;

        .idcard:nth-child(1) {
            background-image: url('@/assets/images/idcard1.png');
        }

        .idcard:nth-child(2) {
            background-image: url('@/assets/images/idcard2.png');
        }

        .idcard {
            width: 135rem;
            height: 96rem;
            background-repeat: no-repeat;
            background-position: center;
            margin: 0 18rem;
            background-size: 100% 100%;
            cursor: pointer;

            input {
                opacity: 0;
                width: 100%;
                height: 100%;
            }
        }

    }

    .desc {
        margin: 20rem;

        h5 {
            margin-bottom: 10rem;
        }

        p {
            color: #A6A6A6;
            font-size: 14rem;
            line-height: 28rem;
        }
    }

    footer {
        display: flex;
        justify-content: space-evenly;
        margin-top: 40rem;
    }
}
</style>
